module.exports = __webpack_public_path__ + "static/media/promotion_image_de.ea370a49.jpg";